var exports = {
  "SA": "VoiceConnectionStatus.module__voiceConnectionContainer___cy1NZl",
  "jf": "VoiceConnectionStatus.module__statusRow___cy1NZl",
  "Tm": "VoiceConnectionStatus.module__channelAvatarStack___cy1NZl",
  "kR": "VoiceConnectionStatus.module__signalIcon___cy1NZl",
  "rI": "VoiceConnectionStatus.module__statusButton___cy1NZl",
  "QQ": "VoiceConnectionStatus.module__statusConnected___cy1NZl",
  "Rg": "VoiceConnectionStatus.module__statusConnecting___cy1NZl",
  "iA": "VoiceConnectionStatus.module__statusDisconnected___cy1NZl",
  "ne": "VoiceConnectionStatus.module__controls___cy1NZl",
  "uH": "VoiceConnectionStatus.module__controlButton___cy1NZl",
  "wH": "VoiceConnectionStatus.module__selected___cy1NZl",
  "Kk": "VoiceConnectionStatus.module__icon___cy1NZl",
  "Hd": "VoiceConnectionStatus.module__connectionInfo___cy1NZl",
  "J3": "VoiceConnectionStatus.module__channelSourceRow___cy1NZl",
  "Dt": "VoiceConnectionStatus.module__channelSourceLink___cy1NZl",
  "_R": "VoiceConnectionStatus.module__channelSourceText___cy1NZl",
  "wl": "VoiceConnectionStatus.module__channelSourceChannel___cy1NZl",
  "EF": "VoiceConnectionStatus.module__channelSourceSeparator___cy1NZl",
  "_u": "VoiceConnectionStatus.module__channelSourceGuild___cy1NZl",
  "wt": "VoiceConnectionStatus.module__connectionIdRow___cy1NZl",
  "TR": "VoiceConnectionStatus.module__connectionIdValue___cy1NZl",
  "Gh": "VoiceConnectionStatus.module__connectionIdValueText___cy1NZl",
  "Hz": "VoiceConnectionStatus.module__connectionIdIcon___cy1NZl",
  "EU": "VoiceConnectionStatus.module__mediaSection___cy1NZl",
  "LA": "VoiceConnectionStatus.module__mediaButton___cy1NZl",
  "A1": "VoiceConnectionStatus.module__cameraActive___cy1NZl",
  "Cb": "VoiceConnectionStatus.module__screenShareActive___cy1NZl",
  "cU": "VoiceConnectionStatus.module__mediaIcon___cy1NZl",
  "jC": "VoiceConnectionStatus.module__popoutContainer___cy1NZl",
  "oO": "VoiceConnectionStatus.module__popoutBodyScroller___cy1NZl",
  "$V": "VoiceConnectionStatus.module__popoutBodyContent___cy1NZl",
  "hY": "VoiceConnectionStatus.module__popoutHeader___cy1NZl",
  "Gb": "VoiceConnectionStatus.module__popoutTitle___cy1NZl",
  "IZ": "VoiceConnectionStatus.module__popoutCloseButton___cy1NZl",
  "nO": "VoiceConnectionStatus.module__popoutStats___cy1NZl",
  "u$": "VoiceConnectionStatus.module__popoutStatsSection___cy1NZl",
  "yk": "VoiceConnectionStatus.module__popoutStatsSectionTitle___cy1NZl",
  "r6": "VoiceConnectionStatus.module__popoutStatsSectionRows___cy1NZl",
  "m1": "VoiceConnectionStatus.module__detailedStatsAccordion___cy1NZl",
  "G8": "VoiceConnectionStatus.module__detailedStatsButton___cy1NZl",
  "X6": "VoiceConnectionStatus.module__detailedStatsButtonText___cy1NZl",
  "VV": "VoiceConnectionStatus.module__detailedStatsCaret___cy1NZl",
  "hM": "VoiceConnectionStatus.module__detailedStatsContent___cy1NZl",
  "cl": "VoiceConnectionStatus.module__detailedStatsInner___cy1NZl",
  "gm": "VoiceConnectionStatus.module__popoutStatRow___cy1NZl",
  "Ub": "VoiceConnectionStatus.module__popoutStatLabel___cy1NZl",
  "Fz": "VoiceConnectionStatus.module__popoutStatValue___cy1NZl",
  "ep": "VoiceConnectionStatus.module__popoutStatTextValue___cy1NZl",
  "mp": "VoiceConnectionStatus.module__deviceBadge___cy1NZl",
  "Vs": "VoiceConnectionStatus.module__deviceBadgeText___cy1NZl",
  "hn": "VoiceConnectionStatus.module__endpointBadge___cy1NZl",
  "iu": "VoiceConnectionStatus.module__endpointBadgeText___cy1NZl",
  "_v": "VoiceConnectionStatus.module__chartContainer___cy1NZl",
  "nS": "VoiceConnectionStatus.module__chartSvg___cy1NZl",
  "$s": "VoiceConnectionStatus.module__gridLine___cy1NZl",
  "rK": "VoiceConnectionStatus.module__gridLineHorizontal___cy1NZl",
  "eB": "VoiceConnectionStatus.module__gridText___cy1NZl",
  "BC": "VoiceConnectionStatus.module__chartLine___cy1NZl",
  "Pi": "VoiceConnectionStatus.module__chartPoint___cy1NZl",
  "Hh": "VoiceConnectionStatus.module__textGreen___cy1NZl",
  "NV": "VoiceConnectionStatus.module__textBackgroundModifierHover___cy1NZl",
  "Bx": "VoiceConnectionStatus.module__iconSmall___cy1NZl",
  "Kt": "VoiceConnectionStatus.module__deviceIcon___cy1NZl",
  "hz": "VoiceConnectionStatus.module__lockIcon___cy1NZl",
  "Gy": "VoiceConnectionStatus.module__nsModalContent___cy1NZl",
  "uU": "VoiceConnectionStatus.module__nsOptions___cy1NZl",
};

module.exports = exports;
